import type React from 'react'

export function isReactElement<P = any>(
  el: React.ReactNode
): el is React.ReactElement<P> {
  return typeof el !== 'string' && typeof el !== 'number'
}
